<div>
  <h4>{{casingPlan.casingType}}</h4>
  @if (casingPlan.cementSource) {
    <p>Cement Source: {{casingPlan.cementSource}}</p>
  }
  @if (casingPlan.boreholeDepth) {
    <p>Borehole Depth: {{casingPlan.boreholeDepth}}</p>
  }
  @if (casingPlan.boreholeDiameter) {
    <p>Borehole Diameter: {{casingPlan.boreholeDiameter}}</p>
  }
  @if (casingPlan.casingLength) {
    <p>Casing Length: {{casingPlan.casingLength}}</p>
  }
  @if (casingPlan.cementClass) {
    <p>Casing Grade: {{casingPlan.cementClass}}</p>
  }
  @if (casingPlan.casingWeight) {
    <p>Casing Weight: {{casingPlan.casingGrade}}</p>
  }
  @if (casingPlan.numberOfCentralizers) {
    <p>Number Centralizers: {{casingPlan.numberOfCentralizers}}</p>
  }
  @if (casingPlan.guideShoeLength) {
    <p>Guide Shoe Length: {{casingPlan.guideShoeLength}}</p>
  }
  @if (casingPlan.floatCollarDepth) {
    <p>Float Collar Depth: {{casingPlan.floatCollarDepth}}</p>
  }
  @if (casingPlan.basketDepth) {
    <p>Basket Depth: {{ casingPlan.basketDepth }}</p>
  }
  @if (casingPlan.packerDepth) {
    <p>Packer Depth: {{ casingPlan.packerDepth}}</p>
  }
  @if (casingPlan.dvToolDepth) {
    <p>DV Tool Depth: {{ casingPlan.dvToolDepth }}</p>
  }
  @if (casingPlan.cementClass) {
    <p>Cement Class: {{casingPlan.cementClass}}</p>
  }
  @if (casingPlan.cementVolume) {
    <p>Cement Volume: {{casingPlan.cementVolume}}</p>
  }
  @if (true) {
    <p>Slurry Yield: {{ slurryYield}}</p>
  }
</div>
